import { ResourcesBlock, ResourcesListProps } from "@/app/parts/global/ResourcesSection";
import productDetail from "@/styles/modules/product_detail.module.scss";
import React from "react";
import clsx from 'clsx';

interface ProductResourcesSectionProps {
    resources: any
    className?: string;
}

export const ProductResourcesSection = (_props: ProductResourcesSectionProps): React.FunctionComponentElement<ProductResourcesSectionProps> =>
{
    const classes = clsx(
      productDetail.product_detail,
      _props.className
    );

    return (

      <div className={classes}>
          <ResourcesBlock title={'Resources'} items={_props.resources} />
      </div>
    )
}